import {Component, Input, OnChanges} from '@angular/core';
import {EnvironmentConfiguration} from './EnvironmentConfiguration';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'risk-icon',
  template: `
    @if (url) {
      <img [ngSrc]="url" [width]="size" [height]="size" [alt]="riskType + ' icon'"/>
    } @else {
      <div [style]="{'width.px': size, 'height.px': size}"></div>
    }
  `,
  imports: [
    NgOptimizedImage
  ],
  standalone: true
})
export class RiskIconComponent implements OnChanges {

  @Input() riskType: string;
  @Input() size = 30;

  public baseIconUrl = EnvironmentConfiguration.urls.picto;
  public url: string;

  get iconUrl(): string {
    if (!this.riskType) {
      return null;
    }
    return `${this.baseIconUrl}picto/inforisque/${this.riskType}/${this.size}.png?size=${this.size}&format=png&cursor=false`;
  }

  ngOnChanges(): void {
    this.url = this.iconUrl;
  }
}
